import {types} from 'mobx-state-tree';

import ContentItems from '../models/content-items';
import Alert from '../models/alert';
import Roles from '../models/roles';

export const NewMasterStore = types.model('NewMasterStore', {
  ContentItems: types.optional(ContentItems, {}),
  alert: types.optional(Alert, {}),
  Roles: types.optional(Roles, {}),
  mode: types.optional(types.enumeration('Mode', ['VIEW', 'VIEW-AS', 'EDIT']), 'VIEW')
})
.actions((self) => {
  return {
    changeMode(newStatus) {
      self.mode = newStatus;
    }
  }
})
.views((self) => {
  return {
    get isInEditMode() {
      return (self.mode === 'EDIT');
    }
  }
})
